import CampaignResultTopNav from "../campaignResultTopNav/campaignResultTopNav";
import "./campaignResultLayout.scss";

export default function CampaignResultLayout(props: {
  children: any;
  title?: string;
  decription?: string;
}) {
  return (
    <div className="campaign-result-layout">
      <CampaignResultTopNav title={props.title} decription={props.decription} />
      <div className="campaign-result-layout-children-container">
        <div className="campaign-result-layout-children">{props.children}</div>
      </div>
    </div>
  );
}
